<section class="sidebar-wrapper" [ngClass]="{ collapsedClass: sidebarData }">
  <div class="header">
    <img src="assets/images/login-img.png" alt="Logo" />
  </div>
  <div class="nav-items-wrapper">
    <ul class="main-nav-list">
      <!-- Dashboard -->
      <li
        class="nav"
        [ngClass]="{ 'active-class': isRouteActive('/dashboard') }"
        (click)="navigateTo('/dashboard')"
      >
        <img
          src="assets/images/icons/icon-dashboard-2.svg"
          alt="icon Dashboard"
          matTooltip="Dashboard"
          matTooltipPosition="right"
        />
        <h3>Dashboard</h3>
      </li>

      <!-- Branch -->
      <li
        class="nav"
        [ngClass]="{ 'active-class': isRouteActive('/branch') }"
        (click)="navigateTo('/branch')"
        *ngIf="isModuleIdInUserModules(routeModuleMap['/branch'])"
      >
        <img
          src="assets/images/icons/icon-branch.svg"
          alt="icon Branch"
          matTooltip="Branch"
          matTooltipPosition="right"
        />
        <h3>Branch</h3>
      </li>

      <!-- Task -->
      <!-- <li
        class="nav"
        [ngClass]="{ 'active-class': isRouteActive('/tasks') }"
        (click)="navigateTo('/tasks')"
      >
        <img
          src="assets/images/icons/icon-branch.svg"
          alt="icon Branch"
          matTooltip="Tasks"
          matTooltipPosition="right"
        />
        <h3>Task Management</h3>
      </li> -->

      <!-- Service -->
      <!-- <li
        class="nav"
        [ngClass]="{ 'active-class': isRouteActive('/services') }"
        (click)="navigateTo('/services')"
      >
        <img
          src="assets/images/icons/icon-branch.svg"
          alt="icon Branch"
          matTooltip="Tasks"
          matTooltipPosition="right"
        />
        <h3>Service Management</h3>
      </li> -->

      <!-- Expenses -->
      <li
        class="nav"
        [ngClass]="{ 'active-class': isRouteActive('/expenses') }"
        (click)="navigateTo('/expenses')"
        *ngIf="isModuleIdInUserModules(routeModuleMap['/expenses'])"
      >
        <img
          src="assets/images/icons/icon-branch.svg"
          alt="icon Expenses"
          matTooltip="Expenses"
          matTooltipPosition="right"
        />
        <h3>Expenses</h3>
      </li>

      <li
        class="nav"
        [ngClass]="{ 'active-class': isRouteActive('/banking') }"
        (click)="navigateTo('/banking')"
        *ngIf="isModuleIdInUserModules(routeModuleMap['/banking'])"
      >
        <img
          src="assets/images/icons/icon-bank-2.svg"
          alt="icon Banking"
          matTooltip="Banking"
          matTooltipPosition="right"
        />
        <h3>Banking</h3>
      </li>

      <li
        class="nav"
        [ngClass]="{ 'active-class': isRouteActive('/accommodation') }"
        (click)="navigateTo('/accommodation')"
        *ngIf="isModuleIdInUserModules(routeModuleMap['/accommodation'])"
      >
        <img
          src="assets/images/icons/accommodation.svg"
          alt="icon Dashboard"
          matTooltip="Accommodation"
          matTooltipPosition="right"
        />
        <h3>Accommodation</h3>
      </li>

      <li
        class="nav"
        [ngClass]="{ 'active-class': isRouteActive('/petty-cash') }"
        (click)="navigateTo('/petty-cash')"
        *ngIf="isModuleIdInUserModules(routeModuleMap['/petty-cash'])"
      >
        <img
          src="assets/images/icons/icon-petty-cash1.svg"
          alt="icon Petty Cash"
          matTooltip="Petty Cash"
          matTooltipPosition="right"
        />
        <h3>Petty Cash</h3>
      </li>
      <li
        class="nav dropdown-nav"
        [ngClass]="{ 'active-class': isRouteActive2(serviceRoutes) }"
        *ngIf="filteredServiceRoutes.length > 0"
      >
        <mat-accordion>
          <mat-expansion-panel [expanded]="mattabnumber == 1">
            <mat-expansion-panel-header (click)="onPanelClick()">
              <mat-panel-title>
                <img
                  src="assets/images/icons/icon-sales.svg"
                  alt="icon SALES"
                  matTooltip="SERVICE"
                  matTooltipPosition="right"
                />
                <h3>Service</h3>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ul class="sub-nav">
              <li
                *ngFor="let route of filteredServiceRoutes"
                [ngClass]="{ active: isRouteActive(route) }"
                (click)="navigateTo(route)"
              >
                {{ getRouteLabel(route) }}
              </li>
            </ul>
          </mat-expansion-panel>
        </mat-accordion>
      </li>
      <li
        class="nav dropdown-nav"
        [ngClass]="{ 'active-class': isRouteActive2(salesRoutes) }"
        *ngIf="filteredSalesRoutes.length > 0"
      >
        <mat-accordion>
          <mat-expansion-panel [expanded]="mattabnumber == 2">
            <mat-expansion-panel-header (click)="onPanelClick()">
              <mat-panel-title>
                <img
                  src="assets/images/icons/icon-sales.svg"
                  alt="icon SALES"
                  matTooltip="SALES"
                  matTooltipPosition="right"
                />
                <h3>Sales</h3>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ul class="sub-nav">
              <li
                *ngFor="let route of filteredSalesRoutes"
                [ngClass]="{ active: isRouteActive(route) }"
                (click)="navigateTo(route)"
              >
                {{ getRouteLabel(route) }}
              </li>
            </ul>
          </mat-expansion-panel>
        </mat-accordion>
      </li>

      <li
        class="nav dropdown-nav"
        [ngClass]="{ 'active-class': isRouteActive2(purchaseRoute) }"
        *ngIf="filteredPurchaseRoutes.length > 0"
      >
        <mat-accordion>
          <mat-expansion-panel [expanded]="mattabnumber == 3">
            <mat-expansion-panel-header (click)="onPanelClick()">
              <mat-panel-title>
                <img
                  src="assets/images/icons/icon-purchase.svg"
                  alt="icon SALES"
                  matTooltip="SALES"
                  matTooltipPosition="right"
                />
                <h3>Purchase</h3>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ul class="sub-nav">
              <li
                *ngFor="let route of filteredPurchaseRoutes"
                [ngClass]="{ active: isRouteActive(route) }"
                (click)="navigateTo(route)"
              >
                {{ getRouteLabel(route) }}
              </li>
            </ul>
          </mat-expansion-panel>
        </mat-accordion>
      </li>

      <!-- HRMS -->
      <li
        class="nav dropdown-nav"
        [ngClass]="{ 'active-class': isRouteActive2(hrmsRoutes) }"
        *ngIf="filteredHrmsRoutes.length > 0"
      >
        <mat-accordion>
          <mat-expansion-panel [expanded]="mattabnumber == 4">
            <mat-expansion-panel-header (click)="onPanelClick()">
              <mat-panel-title>
                <img
                  src="assets/images/icons/icon-hrms.svg"
                  alt="icon HRMS"
                  matTooltip="HRMS"
                  matTooltipPosition="right"
                />
                <h3>HRMS</h3>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ul class="sub-nav">
              <li
                *ngFor="let route of filteredHrmsRoutes"
                [ngClass]="{ active: isRouteActive(route) }"
                (click)="navigateTo(route)"
              >
                {{ getRouteLabel(route) }}
              </li>
            </ul>
          </mat-expansion-panel>
        </mat-accordion>
      </li>

      <li
        class="nav dropdown-nav"
        [ngClass]="{ 'active-class': isRouteActive2(filteredAssetsRoutes) }"
        *ngIf="filteredAssetsRoutes.length > 0"
      >
        <mat-accordion>
          <mat-expansion-panel [expanded]="mattabnumber == 3">
            <mat-expansion-panel-header (click)="onPanelClick()">
              <mat-panel-title>
                <img
                  src="assets/images/icons/icon-assets.svg"
                  alt="icon assets"
                  matTooltip="assets"
                  matTooltipPosition="right"
                />
                <h3>Assets</h3>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ul class="sub-nav">
              <li
                *ngFor="let route of filteredAssetsRoutes"
                [ngClass]="{ active: isRouteActive(route) }"
                (click)="navigateTo(route)"
              >
                {{ getRouteLabel(route) }}
              </li>
            </ul>
          </mat-expansion-panel>
        </mat-accordion>
      </li>

      <li
        class="nav dropdown-nav"
        [ngClass]="{
          'active-class': isRouteActive2([
            '/currency-adjustments',
            '/chart-of-accounts',
            '/manual-journals',
            '/configure',
            '/activity-log'
          ])
        }"
        *ngIf="filteredAccountsRoutes.length > 0"
      >
        <mat-accordion>
          <mat-expansion-panel [expanded]="mattabnumber == 5">
            <mat-expansion-panel-header (click)="onPanelClick()">
              <mat-panel-title>
                <img
                  src="assets/images/icons/icon-accounts.svg"
                  alt="icon Accounts"
                  matTooltip="Accounts"
                  matTooltipPosition="right"
                />
                <h3>Accounts</h3>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ul class="sub-nav">
              <li
                *ngFor="let routes of filteredAccountsRoutes"
                [ngClass]="{ active: isRouteActive(routes) }"
                (click)="navigateTo(routes)"
              >
                {{ getRouteLabel(routes) }}
              </li>
            </ul>
          </mat-expansion-panel>
        </mat-accordion>
      </li>

      <li
        class="nav"
        [ngClass]="{ 'active-class': isRouteActive('/reports') }"
        (click)="navigateTo('/reports')"
        *ngIf="isModuleIdInUserModules(routeModuleMap['/reports'])"
      >
        <img
          src="assets/images/icons/icon-report.svg"
          alt="icon Report"
          matTooltip="Report"
          matTooltipPosition="right"
        />
        <h3>Reports</h3>
      </li>

      <li
        class="nav"
        [ngClass]="{ 'active-class': isRouteActive('/notification-template') }"
        (click)="navigateTo('/notification-template')"
        *ngIf="isModuleIdInUserModules(routeModuleMap['/notification-template'])"
      >
        <img
          src="assets/images/icons/icon-roles.svg"
          alt="icon Roles"
          matTooltip="Notification Template"
          matTooltipPosition="right"
        />
        <h3>Notification Template</h3>
      </li>
      <li
        class="nav"
        [ngClass]="{ 'active-class': isRouteActive('/roles') }"
        (click)="navigateTo('/roles')"
      >
        <img
          src="assets/images/icons/icon-roles.svg"
          alt="icon Roles"
          matTooltip="Roles & Permissions"
          matTooltipPosition="right"
        />
        <h3>Roles & Permissions</h3>
      </li>
    </ul>
  </div>
</section>
